import React from "react";
import { useNavigate } from "react-router-dom";
import { useContent } from "@/lib/queries";
import { Card, Overline } from "@/components/kit";
import architecture from "@/assets/architecture.webp";
import { ChevronRight } from "lucide-react";

export default function Learn() {
  const navigate = useNavigate();
  const { data: content } = useContent();
  if (!content) return <div className="text-inkfaint text-sm animate-pulse">Loading…</div>;

  return (
    <div className="em-fade-up" data-testid="learn-page">
      <Overline>Part I · The Teaching</Overline>
      <h1 className="font-serif text-4xl sm:text-5xl text-ink mt-2">Learn</h1>
      <p className="text-inksoft mt-4 mb-8 max-w-xl leading-relaxed">
        Before you begin the months, meet the ideas beneath them. Read these in any order: return
        whenever you feel stuck, curious or surprised.
      </p>

      <button onClick={() => navigate("/reference")} data-testid="reference-card" className="w-full text-left mb-6">
        <Card className="flex items-center gap-4 hover:border-goldmuted/40 transition-colors">
          <img src={architecture} alt="The Architecture of Human Experience reference chart"
            className="w-16 h-20 object-cover rounded-lg border border-line" />
          <div className="flex-1">
            <Overline>Visual maps</Overline>
            <div className="text-ink font-semibold mt-1">The Architecture &amp; the 12 Modes</div>
            <p className="text-inkfaint text-sm mt-1">Two reference charts to keep beside you as you journal.</p>
          </div>
          <ChevronRight className="w-5 h-5 text-inkfaint" />
        </Card>
      </button>

      <div className="space-y-3">
        {content.chapters.map((c) => (
          <button key={c.slug} onClick={() => navigate(`/read/${c.slug}`)} data-testid={`chapter-${c.slug}`}
            className="w-full text-left">
            <Card className="flex items-center gap-4 hover:border-goldmuted/40 transition-colors">
              <div className="flex-1">
                <div className="font-serif text-xl text-ink">{c.title}</div>
                <p className="text-inkfaint text-sm mt-1">{c.subtitle}</p>
                <div className="text-xs text-faint mt-2">{c.minutes} min read</div>
              </div>
              <ChevronRight className="w-5 h-5 text-inkfaint" />
            </Card>
          </button>
        ))}
      </div>
    </div>
  );
}
